import { OrderStatus } from "../../../../core/schema/OrderStatus.js";
import { DotType } from "../../Dot.js";

export const orderStatusDotTypeMap: Record<OrderStatus, DotType> = {
	[OrderStatus.Accepted]: DotType.Info,
	[OrderStatus.Manufactured]: DotType.Info,
	[OrderStatus.ReadyForPickup]: DotType.Success,
	[OrderStatus.Delivered]: DotType.Success,
	[OrderStatus.Cancelled]: DotType.Error,
};
